import { PayoutMethod } from '@/types/api/payout-account';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { z } from 'zod';

export const createPayoutAccountSchema = z
  .object({
    payoutMethod: z.nativeEnum(PayoutMethod),
    selectionId: z.string().optional(),
    swishNumber: z
      .string()
      .trim()
      .refine(
        (value) => {
          if (!value) return true;
          const phoneNumber = parsePhoneNumberFromString(value, 'SE');
          return phoneNumber?.isValid();
        },
        { message: 'Ogiltigt mobilnummer' },
      )
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.payoutMethod === PayoutMethod.BankTransfer && !data.selectionId) {
      ctx.addIssue({
        code: 'custom',
        path: ['selectionId'],
        message: 'Du måste välja ett bankkonto',
      });
    }
    if (data.payoutMethod === PayoutMethod.Swish && !data.swishNumber) {
      ctx.addIssue({
        code: 'custom',
        path: ['swishNumber'],
        message: 'Swishnummer krävs',
      });
    }
  });
